module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("bGNzU"))).then(() => parcelRequire('dGVXW'));